const areas = [
  { name: 'Stillwater', icon: 'ri-map-pin-line' },
  { name: 'Enid', icon: 'ri-map-pin-line' },
  { name: 'Ponca City', icon: 'ri-map-pin-line' },
  { name: 'Guthrie', icon: 'ri-map-pin-line' },
  { name: 'Perkins', icon: 'ri-map-pin-line' },
  { name: 'Perry', icon: 'ri-map-pin-line' },
  { name: 'Cushing', icon: 'ri-map-pin-line' },
  { name: 'Morrison', icon: 'ri-map-pin-line' }
];

export default function AreasServed() {
  return (
    <section id="areas" className="py-24 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            <strong>Areas</strong> We Serve
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Providing professional handyman services throughout Northern Oklahoma. We're proud to serve these communities with reliable, quality workmanship.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
          {areas.map((area, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-all duration-300 cursor-pointer group"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4 group-hover:bg-teal-600 transition-colors">
                <i className={`${area.icon} text-2xl text-teal-600 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900">{area.name}</h3>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-lg">
          <div className="aspect-video w-full rounded-lg overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d207234.8!2d-97.0584!3d36.1156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87b0e6f3c3c3c3c3%3A0x3c3c3c3c3c3c3c3c!2sStillwater%2C%20OK!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Service Areas Map"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}